var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftPrimary(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0253 12.4712C10.2856 12.2109 10.2856 11.7888 10.0253 11.5284L6.49668 7.99984L10.0253 4.47124C10.2856 4.21089 10.2856 3.78878 10.0253 3.52843C9.76493 3.26808 9.34282 3.26808 9.08247 3.52843L5.08247 7.52843C4.82212 7.78878 4.82212 8.21089 5.08247 8.47124L9.08247 12.4712C9.34282 12.7316 9.76493 12.7316 10.0253 12.4712Z",
    fill: "#33A0AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftPrimary);
export default __webpack_public_path__ + "static/media/arrow-left-primary.d690dd8463a943e202ffb18b47ed44e6.svg";
export { ForwardRef as ReactComponent };